import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/AlertDialog';
import { Button } from '@/components/ui/Button';
import { Loader2 } from 'lucide-react';

export interface CancelPlayEventSeriesConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  seriesName: string;
  onConfirm: () => void | Promise<void>;
  loading?: boolean;
}

export function CancelPlayEventSeriesConfirmDialog({
  open,
  onOpenChange,
  seriesName,
  onConfirm,
  loading = false,
}: CancelPlayEventSeriesConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(next) => !loading && onOpenChange(next)}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel series?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-muted-foreground">
              <p>
                All scheduled sessions in <strong className="text-foreground">{seriesName}</strong>{' '}
                will be marked cancelled on the calendar. The series is deactivated so no new
                sessions are generated.
              </p>
              <p>
                Cancelled sessions stay visible on the operator calendar but are removed from the
                public play page and board.
              </p>
              <p>Online payments already collected are not refunded automatically.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button" disabled={loading}>
            Keep series
          </AlertDialogCancel>
          <Button
            type="button"
            variant="destructive"
            disabled={loading}
            onClick={() => void onConfirm()}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
                Cancelling…
              </>
            ) : (
              'Cancel series'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
